import {NgbDateAdapter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import moment, {Moment} from 'moment-timezone';

export class MomentNgbDateAdapter implements NgbDateAdapter<Moment> {

  constructor(private timezone: string) {
  }

  fromModel(value: Moment): NgbDateStruct {
    if (value === undefined) {
      return undefined;
    } else if (value === null) {
      return null;
    } else {
      if (!this.timezone) {
        throw new Error('Timezone not set');
      }

      // If an invalid entry is entered into a text box, that entry is still passed and needs to not cause an error
      // so that it gets to validation code correctly
      if (value.tz) {
        const v = value.clone().tz(this.timezone);
        return {year: v.year(), month: v.month() + 1, day: v.date()};
      } else {
        return <any>value;
      }
    }
  }

  toModel(date: NgbDateStruct): Moment {
    if (date === undefined) {
      return undefined;
    } else if (date === null) {
      return null;
    } else {
      if (!this.timezone) {
        throw new Error('Timezone not set');
      }
      return moment.tz([date.year, date.month - 1, date.day], this.timezone);
    }
  }
}
